// TODO - dayjs
export const dayDiffBetweenDates = (dateA: Date, dateB: Date): number => {
	return Math.ceil(Math.abs(dateA.getTime() - dateB.getTime()) / (1000 * 60 * 60 * 24));
};

export const isValidDate = (date: any): boolean => {
	return date instanceof Date && !isNaN(date.getTime());
  };
